export interface Action<T extends string> {
  [extraProps: string]: unknown
  type: T
}

export interface ActionWithPayload<T extends string, P> extends Action<T> {
  payload: P
}

export function createAction<T extends string>(type: T): Action<T>
export function createAction<T extends string, P>(type: T, payload: P): ActionWithPayload<T, P>
export function createAction<T extends string, P>(type: T, payload?: P) {
  return payload === undefined ? { type } : { type, payload }
}

type FunctionType = (...args: any[]) => any
interface ActionCreatorsMapObject {
  [actionCreator: string]: FunctionType
}

type AnyAction = Action<any> | ActionWithPayload<any, any>
export type ActionsUnion<A extends ActionCreatorsMapObject> = Extract<ReturnType<A[keyof A]>, AnyAction>
